import { ObjectUtil } from 'app/utils/object.util';

export class OverviewBoard {
  /* eslint-disable */
  country: {
    code: string;
  };
  WTUR1_status: number;
  WTUR1_MW_loss: number;
  WTUR1_MW_mag_f: number;
  WTUR1_MW_rated: number;
  WTUR1_MW_theoretical: number;
  WTUR1_per_loadFactor: number;
  WTUR1_per_efficiency: number;
  WNAC1_ExTmp_mag_f: number;
  WNAC1_WdSpd_mag_f: number;
  WNAC1_WdDir_mag_f: number;
  dataAquisitionMax?: number;
  weather_icon: string;
  countryCode: string;
  fe_name: string;
  lat: number;
  lon: number;
  name: string;
  code: string;
  turbines: any[];
  turbinesOverview?: OverviewBoard[];
  hasAlarm: boolean;
  openAlarms: number;
  worst_five?: boolean;
  parkSubType: {};
  /* eslint-enable */

  static mapFromPark(park: any, alarmIds = null) {
    const alarmsMapper = {}
    alarmIds?.forEach(alarms => {
      alarmsMapper[alarms._id_park] = alarms.alarms
    });
    const openAlarms = alarmsMapper[park._id];
    return new OverviewBoard({
      country: park.country,
      code: park.code,
      WTUR1_status: park.data.WTUR1_status.min,
      WTUR1_MW_loss: park.data.WTUR1_MW_loss.sum,
      WTUR1_MW_mag_f: park.data.WTUR1_MW_mag_f.sum,
      WTUR1_MW_rated: park.dataDebbug.WTUR1_MW_rated.sum,
      WTUR1_MW_theoretical: park.data.WTUR1_MW_theoretical.sum,
      WTUR1_per_loadFactor: park.data.WTUR1_per_loadFactor.avg,
      WTUR1_per_efficiency: park.data.WTUR1_per_efficiency.avg,
      WNAC1_ExTmp_mag_f: park.data.WNAC1_ExTmp_mag_f.avg,
      WNAC1_WdSpd_mag_f: park.data.WNAC1_WdSpd_mag_f.avg,
      WNAC1_WdDir_mag_f: park.data.WNAC1_WdDir_mag_f.avg || park.data.WNAC1_Dir_mag_f.avg,
      dataAquisitionMax: park.metaData.dataAquisitionMax.unixTimestamp,
      weather_icon: ObjectUtil.getProperty(park, 'currentWeather.icon', null),
      countryCode: park.country.code,
      fe_name: park.fe_name,
      lat: park.lat,
      lon: park.lon,
      name: park.name,
      turbines: this.sortTurbines(park.turbines),
      turbinesOverview: park.turbines.map(turbine => new OverviewBoard({
        code: turbine.code,
        WTUR1_status: turbine.data?.WTUR1_status,
        WTUR1_MW_loss: turbine.data?.WTUR1_kW_loss,
        WTUR1_MW_mag_f: turbine.data?.WTUR1_kW_mag_f,
        WTUR1_MW_rated: turbine.WTUR1_kW_rated,
        WTUR1_MW_theoretical: turbine.data?.WTUR1_kW_theoretical,
        WTUR1_per_loadFactor: turbine.data?.WTUR1_per_loadFactor,
        WTUR1_per_efficiency: turbine.data?.WTUR1_per_efficiency,
        WNAC1_ExTmp_mag_f: turbine.data?.WNAC1_ExTmp_mag_f,
        WNAC1_WdSpd_mag_f: turbine.data?.WNAC1_WdSpd_mag_f,
        WNAC1_WdDir_mag_f: turbine.data?.WNAC1_WdDir_mag_f,
        weather_icon: null,
        fe_name: turbine.serial,
        name: turbine.serialNav,
      })),
      parkSubType: park.parkSubType,
      hasAlarm: this.hasAlarm(park.turbines),
      openAlarms: openAlarms?.length
    });
  }

  static sortTurbines(turbines: []): [] {
    return turbines.sort((a: any, b: any) => a.code.localeCompare(b.code, undefined, { numeric: true, sensitivity: 'base' }));
  }

  static hasAlarm(turbines: []): boolean {
    const redFound = turbines.filter((turbine: any) =>
      ObjectUtil.getProperty(turbine, 'data.WTUR1_status', null) === 2
    ).length > 0;
    return redFound;
  }

  constructor(init: Partial<OverviewBoard>) {
    Object.assign(this, init);
  }

}
